import { render, staticRenderFns } from "./MyList.vue?vue&type=template&id=6845845e"
import script from "./MyList.vue?vue&type=script&lang=js"
export * from "./MyList.vue?vue&type=script&lang=js"
import style0 from "./MyList.vue?vue&type=style&index=0&id=6845845e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports